import { reactive } from 'vue'
import zhCN from '../i18n/zh-CN'
import zhTW from '../i18n/zh-TW'

const messages = {
  'zh-CN': zhCN,
  'zh-TW': zhTW,
}

const state = reactive({
  locale: localStorage.getItem('locale') || 'zh-CN',
})

export function useI18n() {
  const t = (key) => {
    const keys = key.split('.')
    let result = messages[state.locale]
    for (const k of keys) {
      if (result && typeof result === 'object' && k in result) {
        result = result[k]
      } else {
        // Fallback to the other locale
        const fallbackLocale = state.locale === 'zh-CN' ? 'zh-TW' : 'zh-CN'
        let fallbackResult = messages[fallbackLocale]
        for (const fk of keys) {
          if (fallbackResult && typeof fallbackResult === 'object' && fk in fallbackResult) {
            fallbackResult = fallbackResult[fk]
          } else {
            return key
          }
        }
        return fallbackResult
      }
    }
    return result
  }

  const setLocale = (locale) => {
    state.locale = locale
    localStorage.setItem('locale', locale)
  }

  const toggleLocale = () => {
    const newLocale = state.locale === 'zh-CN' ? 'zh-TW' : 'zh-CN'
    setLocale(newLocale)
  }

  const currentLocale = () => state.locale

  return {
    t,
    setLocale,
    toggleLocale,
    currentLocale,
    locale: state.locale,
  }
}
